
import { defineComponent, ref, nextTick, computed } from 'vue'

export default defineComponent({
  name: 'FiLabelSub',
  props: {
    text: { type: String, required: true },
    color: { type: String, default: '#e8392a' },
    maxWidth: { type: [Number, String], default: '160px' },
  },
  setup(props) {
    const maxWidthStyle = computed(() => {
      const w = props.maxWidth
      return typeof w === 'number' ? `${w}px` : w
    })
    const elRef = ref<HTMLElement | null>(null)
    const tipVisible = ref(false)

    const onEnter = () => {
      nextTick(() => {
        const el = elRef.value
        tipVisible.value = !!(el && el.scrollWidth > el.clientWidth)
      })
    }

    const onLeave = () => {
      tipVisible.value = false
    }

    return { elRef, tipVisible, onEnter, onLeave, maxWidthStyle }
  },
})
